import * as React from 'react';
import keys from './keys';
import { useLocation } from 'react-router-dom';
import { getLocalizationApiUrl } from '../../util/localization.util';
import {
	cultureCodeQueryParamName,
	getCultureCodesFromUrlSearchParams,
	UseLocalizationType,
	LocalizationContext,
	useLocalization,
	en,
} from '@above-the-treeline/localization';
import LoadingApp from '../UI/LoadingApp';
import { useUser } from '../User/containers/UserDataStore';

type LocalizationContainerProps = {
	children: React.ReactNode;
};

const LocalizationContainer = ({
	children,
}: LocalizationContainerProps): JSX.Element => {
	const location = useLocation();
	const { state: user } = useUser();
	const userCultureName = user?.region?.cultureName;
	const userCultureNameOrDefault = userCultureName ? [userCultureName] : [en];

	const localizationData: UseLocalizationType = useLocalization({
		cultureCodes:
			getCultureCodesFromUrlSearchParams(
				cultureCodeQueryParamName,
				location.search,
			) || userCultureNameOrDefault,
		localizationApiUrl: getLocalizationApiUrl(),
		localizationKeys: keys,
	});

	return (
		<LocalizationContext.Provider value={localizationData}>
			{localizationData.isLoading ? <LoadingApp /> : children}
		</LocalizationContext.Provider>
	);
};

export default LocalizationContainer;
